import React from 'react'

function Enquiry() {
  return (
    <div>Enquiry</div>
  )
}

export default Enquiry